var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_7548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4289 17.1429C14.1628 17.1429 18.0004 13.3053 18.0004 8.57143C18.0004 3.83756 14.1628 0 9.4289 0C4.695 0 0.857422 3.83756 0.857422 8.57143C0.857422 13.3053 4.695 17.1429 9.4289 17.1429Z",
    fill: "#404585"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2104 5.64745C13.5533 5.99037 13.5533 6.54636 13.2104 6.88928L11.0994 9.00026L13.2104 11.1112C13.5533 11.4542 13.5533 12.0101 13.2104 12.3531C12.8674 12.696 12.3115 12.696 11.9685 12.3531L9.85756 10.2421L7.74658 12.3531C7.40366 12.696 6.84767 12.696 6.50475 12.3531C6.16183 12.0101 6.16183 11.4542 6.50475 11.1112L8.61572 9.00026L6.50475 6.88929C6.16183 6.54636 6.16183 5.99038 6.50475 5.64745C6.84767 5.30453 7.40366 5.30453 7.74658 5.64745L9.85756 7.75843L11.9685 5.64745C12.3115 5.30453 12.8674 5.30453 13.2104 5.64745Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_7548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.1429,
    fill: "white",
    transform: "translate(0.857422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle .bbf375d164e099cc8e0f1a4b621d5cea.svg";
export { ForwardRef as ReactComponent };